export const getCookie = function getCookie(name) {
    let cookieValue = null
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i += 1) {
            const cookie = cookies[i].trim()
            if (cookie.substring(0, name.length + 1) === `${name}=`) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
                break
            }
        }
    }
    return cookieValue
}

export const setCookie = function setCookie(name, val, exp, pth, dom, scr) {
    // options=options||{};
    let value = val
    let expires = exp
    let path = pth
    let domain = dom
    let secure = scr
    if (value === null) {
        value = ''
        expires = -1
    }
    if (expires && (typeof expires === 'number' || expires.toUTCString)) {
        let date
        if (typeof expires === 'number') {
            date = new Date()
            date.setTime(date.getTime() + expires * 1000)
        } else {
            date = expires
        }
        expires = `;expires=${date.toUTCString()}`
    }
    path = path ? `;path=${path}` : ''
    domain = domain ? `;domain=${domain}` : ''
    secure = secure ? ';secure' : ''
    document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('')
}

const Cookie = {
    get: cname => {
        const name = `${cname}=`
        const ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i += 1) {
            let c = ca[i]
            while (c.charAt(0) === ' ') {
                c = c.substring(1)
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length)
            }
        }
        return ''
    },
    set: (cn, cvv, exp, path, domain, secure) => {
        let cv = cvv
        let expires = exp
        if (cv === undefined || cv === '') {
            cv = ''
            expires = -1
        }

        const n = `${cn}=${encodeURIComponent(cv)}`
        let e = `;expires=${Cookie.expires(expires)}`
        if (expires === -1) e = ''
        const p = path ? `;path=${path}` : ''
        const d = domain ? `;domain=${domain}` : ''
        const s = secure ? ';secure' : ''
        document.cookie = n + e + p + d + s
    },
    expires: exp => {
        const d = new Date()
        if (typeof exp === 'number') {
            d.setTime(d.getTime() + exp * 1000)
        } else if (exp === 'today') {
            d.setHours(24, 0, 0, 0)
        } else if (exp === 'week') {
            d.setDate(d.getDate() + 7)
        } else if (exp === 'month') {
            d.setMonth(d.getMonth() + 1)
        }
        return d.toUTCString()
    },
}
export default Cookie
